import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'
import { defaultTheme } from '../../../theming/data/defaultTheme'
import colors from '../../../tokens/colors'
import border from '../../../tokens/border'

export const LoadingSpinnerWrapper = styled.div.attrs((props) =>
  composeTheme(props),
)`
  min-height: 18px;
  min-width: 18px;

  .base {
    height: 14px;
    width: 14px;
    border-radius: ${border.radius.radiusMd};
    border: 2px solid ${colors.neutralColorLowLight};
    border-right-color: ${colors.brandColorPrimaryPure};
    animation: rotation 1s linear infinite;

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`

LoadingSpinnerWrapper.defaultProps = defaultTheme
